import React from 'react'

const TableBody = props => {
  return <tbody>{props.children}</tbody>
}
export default TableBody
